import {
  GQLAccessoryConfiguration,
  GQLPlatformProducerOrderState,
  GQLPieceConfiguration
} from '@jewelutions/core-crm-server-api-client-domain';
import { userLanguage } from './AuthContext';
import * as Yup from 'yup';
import { saveAs } from 'file-saver';
import { CommonLogic } from '@jewelutions/core-common-logic';

export const OPTION_ALL = 'All';

interface OrderStateSelectOption {
  id: GQLPlatformProducerOrderState | typeof OPTION_ALL;
  name: string;
}

export const successNotification = (toast: any, text: string, onclose: any) => {
  toast.success(text, {
    onclose: { onclose },
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
};

export const merchantOrderStates = Object.entries(GQLPlatformProducerOrderState)
  .filter(([key, value]) => Number.isNaN(Number(key)))
  .map(([key, value]) => {
    return { id: value, name: key } as OrderStateSelectOption;
  });

export function getSelectedMaterials(
  availableConfigurations: (GQLPieceConfiguration | GQLAccessoryConfiguration)[]
) {
  const materialTypes = availableConfigurations.map(
    (it: GQLPieceConfiguration | GQLAccessoryConfiguration) => it.materialType
  );
  return Array.from(new Set<string>(availableConfigurations.map((it: any) => it.materialType))).map(
    (mt: string) => {
      return {
        material: mt,
        platingTypes: availableConfigurations
          .filter((pc: any) => pc.materialType === mt)
          .map((pt: any) => pt.platingType)
      };
    }
  );
}

export function saveCsvFile(content: string, fileName?: string) {
  var blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  saveAs(blob, fileName ? fileName : CommonLogic.generateUUIDv4());
}

export function downloadFromUrl(url: string, fileName?: string) {
  saveAs(url, fileName);
}

export function removeTypename(object: any) {
  const newObj = {} as any;
  Object.keys(object).forEach((key: string) => {
    if (key !== '__typename') {
      newObj[key] = object[key];
    }
  });
  return newObj;
}

export function stringListToSelectOptionList(list: string[]) {
  return list.map((item, index) => {
    return {
      name: item,
      id: index + ''
    };
  });
}

export function stringListToDisplayValueList(list: string[]) {
  return list.map((item, index) => {
    return {
      name: item,
      id: item.toUpperCase().replace(' ', '')
    };
  });
}

export function addTranslationForValidation(schemaObject: any) {
  Object.keys(schemaObject).forEach((k: string) => {
    const obj = {} as any;
    obj[userLanguage] = schemaObject[k];
    schemaObject[k] = Yup.object({ ...obj });
  });
}
